// LIST OF SINGLE EXHIBITION COMPONENTS

import React, { useContext } from "react";
import MetaTags from "react-meta-tags";
import { LanguageContext } from "./../language-context";
import { Link } from "react-router-dom";
import * as variables from "./helper/Variables";
import styled from "styled-components";
import { PageTitle } from "./helper/PageTitle";
import { Exhibition } from "./Exhibition";
import { Scroll } from "./helper/Scroll";
import { ScrollTracker } from "./helper/ScrollTracker";

const ExhibitionsContainer = styled.section`
  background-color: ${variables.BACKGROUND_GRAY};
`;

export const ExhibitionList = () => {
  const usedLanguage = useContext(LanguageContext);

  const { exhibitionsHeader, exhibitionsContainer } =
    usedLanguage.language.exhibitions;

  Scroll();
  ScrollTracker();

  return (
    <main>
      <MetaTags>
        <title>{exhibitionsHeader} | Structuralist</title>
        <meta name="description" content={exhibitionsHeader} />
        <meta
          name="keywords"
          content={`"Structuralist", "Michał Król", ${exhibitionsHeader}`}
        />
      </MetaTags>
      <PageTitle
        text={exhibitionsHeader}
        backgroundColor={variables.BACKGROUND_GRAY} //Styled Components props
      />
      <ExhibitionsContainer>
        {Object.keys(exhibitionsContainer).map((exhibitionId) => {
          return (
            <Link
              to={`/reports/${exhibitionId}`}
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <Exhibition exhibitionId={exhibitionId} key={exhibitionId} />
            </Link>
          );
        })}
      </ExhibitionsContainer>
    </main>
  );
};
